import { StorageHandler } from "@/lib/storage";
import { makeAutoObservable } from "mobx";

export interface SessionState {
  visitedAtUnix?: number;
  expiredTourGuideIds?: string[];
}

export class SessionStateStorage {
  private isPreview: boolean;
  private storage: StorageHandler;
  private _state: SessionState;

  constructor(isPreview: boolean, storage: StorageHandler) {
    this.isPreview = isPreview;
    this.storage = storage;
    this._state = this.get();
    makeAutoObservable(this);
  }

  private storageKey(): string {
    return `pyne-session-state${this.isPreview ? "-preview" : ""}`;
  }

  public isExists(): boolean {
    return this.storage.isKeyExists(this.storageKey());
  }

  public get(): SessionState {
    return this.storage.get(this.storageKey(), {});
  }

  public clear(): void {
    this.storage.remove(this.storageKey());
    this._state = {};
  }

  public set(state: Partial<SessionState>): void {
    this._state = { ...this._state, ...state };
    this.storage.set(this.storageKey(), this._state);
  }

  public setVisitedAt(): number {
    const date = Date.now();
    const visitedAtUnix = this.get().visitedAtUnix;
    if (!visitedAtUnix) {
      this.set({ visitedAtUnix: date });
      return date;
    }
    return visitedAtUnix;
  }

  public getVisitedAt(): number {
    const visitedAtUnix = this.get().visitedAtUnix;
    return visitedAtUnix ? visitedAtUnix : this.setVisitedAt();
  }

  get expiredTourGuideIds(): string[] {
    return this._state.expiredTourGuideIds ?? [];
  }

  public addExpiredGuide(guideId: string): void {
    const expiredTourGuideIds = this._state.expiredTourGuideIds ?? [];
    this._state.expiredTourGuideIds = [...expiredTourGuideIds, guideId];
    this.storage.set(this.storageKey(), this._state);
  }
}
